import {
  GET_EMTITHAL_OFFICE_TASKS,
  EXPORT_EMTITHAL_OFFICE_TASKS_REPORT,
} from '../../../modules/constants';

export function getEmtithalOfficeTasks(value) {
  return {
    type: GET_EMTITHAL_OFFICE_TASKS,
    payload: value,
  };
}

export function exportEmtithalOfficeTasksReport(value) {
  return {
    type: EXPORT_EMTITHAL_OFFICE_TASKS_REPORT,
    payload: value,
  };
}
